type Props = {
  style?: string;
  status: string;
};

const SalonStatus = ({ style, status }: Props) => {
  const colorStatus = (status: string) => {
    switch (status) {
      case "active":
      case "Active":
        return "#479821";
      case "Cancelled ":
      case "cancelled ":
      case "blocked":
      case "Blocked":
        return "#C43535";
      case "pending":
      case "Pending":
        return "#CF953D";
      case "Upcoming":
      case "upcoming":
        return "#00086D";
      default:
        return "#B0B0C0"; // Default color if status doesn't match any case
    }
  };
  return (
    <span
      style={{ background: colorStatus(status) }}
      className={`${style} text-white capitalize p-[3px] px-2 rounded-lg text-sm h-fit w-fit flex items-center hover:!opacity-50 justify-center absolute top-1 right-1`}
    >
      {status}
    </span>
  );
};

export default SalonStatus;
